export default [
    {
        path: '/account-setting',
        name: 'account-setting',
        component: () => import('@/views/account-setting/AccountSetting.vue'),
        meta: {
            resource: 'ACL',
            pageTitle: 'Mi perfil',
            breadcrumb: [
                {
                    text: 'Configuraciones',
                    active: true
                }
            ],
            requiresAuth: true
        }
    }
]